'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    StampStore = require('./StampStore'),
    PaginatedStoreUtils = require('../utils/PaginatedStoreUtils'),
    { createListStore, createListActionHandler } = PaginatedStoreUtils;

var TrendingStore = createListStore();

var handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_TRENDING_STAMPS,
  error: ActionTypes.REQUEST_TRENDING_STAMPS_ERROR,
  success: ActionTypes.REQUEST_TRENDING_STAMPS_SUCCESS,
  preload: ActionTypes.PRELOAD_TRENDING_STAMPS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([StampStore.dispatchToken]);
  handleListAction(payload.action, TrendingStore.getList(), TrendingStore.emitChange);

  switch (payload.action.type) {
    case ActionTypes.FOLLOW_ZINE_SUCCESS:
    case ActionTypes.UNFOLLOW_ZINE_SUCCESS:
    case ActionTypes.FOLLOW_USER_SUCCESS:
    case ActionTypes.UNFOLLOW_USER_SUCCESS:
    case ActionTypes.INVALIDATE_FEED_WITH_TRENDING:
      TrendingStore.invalidate();
      break;
  }
});

module.exports = TrendingStore;


/** WEBPACK FOOTER **
 ** ./stores/TrendingStore.js
 **/